export abstract class BasePayload {
  id: string | null = null;
}
